import { useContext } from 'react'

import {
  CostMessagingModalContent,
  CostMessagingModalCoverageInfo,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

import { AppContext } from '../context'

interface UseShouldShowCoverageMessagingParams {
  isCostMessagingEnabled: boolean
  costMessagingModalCoverageInfo?: CostMessagingModalCoverageInfo
  coverageModalContents?: CostMessagingModalContent[]
}

export const useShouldShowCoverageMessaging = ({
  isCostMessagingEnabled,
  costMessagingModalCoverageInfo,
  coverageModalContents,
}: UseShouldShowCoverageMessagingParams): boolean => {
  const { isHideCostAndSessionLimitEnabled } = useContext(AppContext)

  return (
    !isHideCostAndSessionLimitEnabled &&
    isCostMessagingEnabled &&
    !!costMessagingModalCoverageInfo?.customerCoverageType &&
    !!coverageModalContents &&
    coverageModalContents.length > 0
  )
}
